import {ActivityReview} from '@/containers'
import {ProgressIndicator, HeaderTitle, Breadcrumb} from '@/components/atoms'
import { ROUTES } from '@/utils/constants/routesConstants'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import useActivityReview from '@/containers/Activity/ActivityReview/ActivityReview-hook'
import { getModal } from '@/utils/CommonModal'
import { useAppSelector } from '@/store'
import { useMemo } from 'react'
import {Constants} from '@/utils/constants/commonConstants'

const AddActivityReview = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  const [searchParams] = useSearchParams()
  const activityFormData = useAppSelector(state => state.activity.formData)

  const reviewParam = searchParams.get('review')
  const isReviewCompleted = reviewParam?.toLowerCase() === Constants.ReviewCompleted.toLowerCase();


  const {
    handleCancel,
    onClickPrimaryButton,
    onClickSecondaryButton,
    isCancel,
  } = useActivityReview()

  // Dynamic breadcrumb logic
  const breadcrumbs = useMemo(() => {
    const baseBreadcrumbs = [
      { label: '', href: '/' },
      { label: 'Loyalty Campaigns', href: '/rewards/activities' }
    ];

    // Check if we have an existing activity (either from URL id or data id/uuid)
    const hasExistingActivity = id || activityFormData?.uuid || activityFormData?.id;
    const activityName = activityFormData?.activityName;

    // Creation flow - no id in URL and no existing data
    if (!hasExistingActivity) {
      return [
        ...baseBreadcrumbs,
        { label: 'Add Activity', href: '/rewards/activities' }
      ];
    }

    // Review/Edit flow - id exists in URL or data has id/uuid
    const displayName = activityName || 'Loading...';
    return [
      ...baseBreadcrumbs,
      { label: 'Activity', href: '/rewards/activities' },
      { label: displayName, href: '/rewards/activities' }
    ];
  }, [id, activityFormData?.activityName, activityFormData?.uuid, activityFormData?.id]);

  const handleStepClick = (step) => {
    if (step === 1) {
      navigate(ROUTES.ACTIVITY_ADD)
    }
  }

  const getCancelModal = () => {
    return getModal({
      title: "Are you sure you want to cancel?",
      text: 'Your work will not be saved if you click Yes. To continue editing and go back to the page, click NO',
      showPrimaryButton: true,
      primaryButtonText: "Yes",
      onClickPrimaryButton: onClickPrimaryButton,
      showSecondaryButton: true,
      secondaryButtonText: "No",
      onClickSecondaryButton: onClickSecondaryButton,
      showModal: isCancel,
      onCloseModal: handleCancel,
      hideCloseButton: false
    })
  }

  return (
    <>
      <Breadcrumb
        uiSchema={{
          isDark: true,
          className: 'mb-5',
          breadcrumbs: breadcrumbs,
        }}
        id={'aar_bradcrumb'}
      />
      <HeaderTitle title={'Activity Review'} className="mb-3 justify-start text-3xl font-bold text-slate-200" />
      {!isReviewCompleted && <ProgressIndicator
        currentStep={2}
        completed={false}
        steps={2}
        titles={[{ title: 'Setup' }, { title: 'Review' }]}
        className="mb-6"
        onStepClick={handleStepClick}
      />}
      <br />
      <ActivityReview
        cancelModalHandlers={{
          handleCancel,
          onClickPrimaryButton,
          onClickSecondaryButton,
          isCancel
        }}
      />
      {isCancel && getCancelModal()}
    </>
  )
}

export default AddActivityReview
